import { useState } from "react";
import { useHistory } from "react-router-dom";
import BaseButton from "components/common/BaseButton";
import BaseModal from "../shared/components/BaseModal";
import { useIntl } from "react-intl";
import { usAdminAppRoutes } from "../../../route-definitions";
import EntityPageLayout from "../shared/components/EntityPageLayout";
import useMutateEndUser from "./hooks/useMutateEndUser";
import { EndUserFormData } from "./components/create-end-user-form/create-end-user.schema";
import CreateEndUserForm from "./components/create-end-user-form/CreateEndUserForm";

const CreateEndUserPage = () => {
  const history = useHistory();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const intl = useIntl();

  const {
    createEndUser,
    createEndUserLoading,
    createEndUserSuccess,
    createEndUserError,
  } = useMutateEndUser({
    onCreateSuccess: () => {
      setModalIsOpen(true);
    },
    onCreateError: () => {
      setModalIsOpen(true);
    },
  });

  const onSubmit = (data: EndUserFormData) => {
    createEndUser(data);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
    if (createEndUserSuccess) {
      history.push(usAdminAppRoutes.endUsers);
    }
  };

  return (
    <EntityPageLayout headerMessage="usAdmin.createEndUser">
      <BaseModal
        isOpen={modalIsOpen}
        onRequestClose={handleCloseModal}
        footer={
          <BaseButton
            handleSubmit={handleCloseModal}
            text={intl.formatMessage({ id: "usAdmin.ok" })}
          />
        }
      >
        {createEndUserSuccess && (
          <h2>
            {intl.formatMessage({ id: "usAdmin.endUserCreatedSuccessfully" })}
          </h2>
        )}
        {createEndUserError && (
          <h2>{intl.formatMessage({ id: "usAdmin.endUserExists" })}</h2>
        )}
      </BaseModal>
      <CreateEndUserForm
        onSubmit={onSubmit}
        isSubmitting={createEndUserLoading}
      />
    </EntityPageLayout>
  );
};

export default CreateEndUserPage;
